import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useLocation } from "react-router-dom";
import { Link } from "../link/Link";
import classes from "./Sidebar.module.scss";

export const Sidebar = ({ userInfo, menuContent }) => {
  const location = useLocation();
  return (
    <aside className={`${classes["sidenav-wrapper"]}`}>
      <div className={`${classes["user-info"]}`}>
        <div className={`${classes["name"]}`}>
          {!userInfo ? <Skeleton width={"50%"} /> : userInfo.fullName}
        </div>
        <div className={`${classes["role"]} capitalize`}>
          {!userInfo ? <Skeleton width={"25%"} /> : userInfo.role}
        </div>
      </div>
      <ul className={`${classes["main-menu"]}`}>
        {menuContent.map((item) => (
          <Link to={item.path} inherit key={item.key}>
            <li
              className={`${
                location.pathname.startsWith(item.path) ? classes["active"] : ""
              }`}
            >
              {item.title}
            </li>
          </Link>
        ))}
      </ul>
    </aside>
  );
};
